<section class="login">
  <div class="container">
    <div class="layout-container">
      <div class="layout">
        <div class="login-block compact-card">

          <div class="login-logo small-logo">
            <img class="image-cls" [src]="siteSettings.siteLogo" alt="">
          </div>

          <div class="logo-moto">Enable 2FA</div>

          <div *ngIf="!isSetupLoading" class="twofa-wrapper">

            <div class="info-text">
              <p>
                Install <strong>Google Authenticator</strong> app →
                Click <strong>+</strong> →
                Scan QR or Enter Key →
                Verify below.
              </p>
            </div>

            <div class="qr-section">
              <img [src]="qrCodeImage" alt="QR Code" class="qr-img">
            </div>

            <div class="manual-code-box">
              <span>{{ manualCode }}</span>
              <button mat-stroked-button color="primary" type="button" (click)="copyCode()">
                Copy
              </button>
            </div>

            <form [formGroup]="form" (ngSubmit)="formSubmitHandler()" class="verify-form">

              <mat-form-field appearance="outline" class="full-width">
                <input
                  matInput
                  formControlName="code"
                  placeholder="Enter 6 Digit Code"
                  maxlength="6">
                <mat-icon matSuffix>security</mat-icon>
              </mat-form-field>

              <button
                mat-raised-button
                color="primary"
                type="submit"
                [disabled]="form.invalid || isLoading"
                class="full-width enable-btn">
                Enable 2FA
              </button>

            </form>

          </div>

          <div class="login-copyright small-copy">
            <p>© {{year}} {{ siteSettings.siteName }}</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>